import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    Button, Select, FormControl, MenuItem, InputLabel
} from '@mui/material';
import { withStyles } from '@mui/styles';
import { isEqual } from 'lodash';
import { getDataModification } from '../../../utils';
import MultiTypeahead from './MultiTypeahead';
import OSVersionTypeahead from './OSVersionTypeahead';

const range = {
    FROM: 'FROM',
    TO: 'TO'
};

const styles = {
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignContent: 'center',

        width: '100%',
        marginTop: '2%'
    },
    rangeButton: {
        width: '49%'
    },
    smallFormControl: {
        width: '45%'
    }
};

class OSVersionSelectTypeahead extends Component {
    state = {
        osType: this.props.rangeOSVersion.osVersion,
        versionFrom: this.props.versionsList ? this.props.versionsList[0] : null,
        versionTo: this.props.versionsList ? this.props.versionsList[this.props.versionsList.length - 1] : null,
        currentVersionsArrayFrom: [],
        currentVersionsArrayTo: [],
        sortedOsArray: getDataModification(this.props.osVersions)
    };

    handleChangeRange = async () => {
        await this.props.handleChangeRangeType('isRanged', !this.props.rangeOSVersion.isRanged);
        this.setState({
            sortedOsArray: getDataModification(this.props.osVersions, !this.props.rangeOSVersion.isRanged)
        },
        () => this.handleChangeFilter()
        );
    };

    handleChangeType = event => {
        let { versionFrom, versionTo } = this.state;

        [versionFrom] = this.props.versionsList.slice(0, 1);
        [versionTo] = this.props.versionsList.slice(-1);

        const versionFromNoName = this.state.sortedOsArray[this.props.rangeOSVersion.osVersion]?.find(
            i => i.value === versionFrom?.value
        );
        const versionToNoName = this.state.sortedOsArray[this.props.rangeOSVersion.osVersion]?.find(
            i => i.value === versionTo?.value
        );

        this.setState({
            versionFrom: versionFromNoName,
            versionTo: versionToNoName,
            osType: this.props.rangeOSVersion.osVersion,
        });

        // TODO: need to simplify
        let currentOsName = '';

        if (this.props.rangeOSVersion.osVersion && (!event || !event.target)) {
            currentOsName = this.props.rangeOSVersion.osVersion;
            const indexFrom = this.state.sortedOsArray[currentOsName].findIndex(
                i => i.value === versionFrom?.value
            );
            const indexTo = this.state.sortedOsArray[currentOsName].findIndex(
                i => i.value === versionTo?.value
            );
            this.setState({
                currentVersionsArrayFrom: this.state.sortedOsArray[currentOsName].filter((elem, i) => i < indexTo),
                currentVersionsArrayTo: this.state.sortedOsArray[currentOsName].filter((elem, i) => i > indexFrom)
            });
        } else {
            currentOsName = event.target.value;
            this.props.handleChangeRangeType('osVersion', currentOsName);
            const currentOsVersionsArray = this.state.sortedOsArray[currentOsName];

            this.setState(
                {
                    versionTo: this.state.sortedOsArray[currentOsName][currentOsVersionsArray.length - 1],
                    versionFrom: this.state.sortedOsArray[currentOsName][0],
                    osType: currentOsName,
                    currentVersionsArrayFrom: currentOsVersionsArray,
                    currentVersionsArrayTo: currentOsVersionsArray
                },
                () => {
                    this.handleChangeFilter();
                }
            );
        }
    };

    getSuggestionIndex = suggestion =>
        this.state.sortedOsArray[this.state.osType].findIndex(i => i.value === suggestion);

    addVersion = type => suggestion => {
        const suggestionIndex = this.getSuggestionIndex(suggestion.value);

        if (type === range.FROM) {
            this.addVersionFrom(suggestionIndex);
        }

        if (type === range.TO) {
            this.addVersionTo(suggestionIndex);
        }
    };

    addVersionFrom = suggestionIndex => {
        this.setState(
            {
                versionFrom: this.state.sortedOsArray[this.state.osType][suggestionIndex],
                currentVersionsArrayTo: this.state.sortedOsArray[this.state.osType].filter(
                    (elem, i) => i > suggestionIndex
                )
            },
            () => {
                this.handleChangeFilter();
            }
        );
    };

    addVersionTo = suggestionIndex => {
        this.setState(
            {
                versionTo: this.state.sortedOsArray[this.state.osType][suggestionIndex],
                currentVersionsArrayFrom: this.state.sortedOsArray[this.state.osType].filter(
                    (elem, i) => i < suggestionIndex
                )
            },
            () => {
                this.handleChangeFilter();
            }
        );
    };

    handleChangeFilter = () => {
        if (this.state.versionFrom && this.state.versionTo) {
            const indexFrom = this.state.sortedOsArray[this.state.osType]?.findIndex(
                i => i.value === this.state.versionFrom.value
            );
            const indexTo = this.state.sortedOsArray[this.state.osType]?.findIndex(
                i => i.value === this.state.versionTo.value
            );
            const currentOsVersionsArray = this.state.sortedOsArray[this.state.osType]?.slice(indexFrom, indexTo + 1);
            this.props.onChangeSuggestion(currentOsVersionsArray);
        }
    };

    componentDidUpdate(prevProps) {
        if (this.props.rangeOSVersion.osVersion && !isEqual(prevProps, this.props)) {
            this.handleChangeType();
        }
        if (!isEqual(prevProps, this.props)) {
            this.setState({
                osType: this.props.rangeOSVersion.osVersion,
                versionFrom: this.props.versionsList ? this.props.versionsList[0] : null,
                versionTo: this.props.versionsList ? this.props.versionsList[this.props.versionsList.length - 1] : null,
                sortedOsArray: getDataModification(this.props.osVersions)
            });
        }
    }

    render() {
        const { classes, versionsList, rangeOSVersion, osVersions, t } = this.props;
        const {
            versionFrom,
            currentVersionsArrayFrom,
            versionTo,
            currentVersionsArrayTo,
            sortedOsArray
        } = this.state;
        const OsNamesArray = Object.keys(sortedOsArray);

        return (
            <React.Fragment>
                <div className={classes.container}>
                    <Button
                        className={classes.rangeButton}
                        variant={!rangeOSVersion.isRanged ? 'contained' : 'outlined'}
                        color="secondary"
                        size="small"
                        onClick={rangeOSVersion.isRanged ? this.handleChangeRange : null}
                    >
                        {t('oneOS')}
                    </Button>
                    <Button
                        className={classes.rangeButton}
                        variant={rangeOSVersion.isRanged ? 'contained' : 'outlined'}
                        color="secondary"
                        size="small"
                        onClick={!rangeOSVersion.isRanged ? this.handleChangeRange : null}
                    >
                        {t('rangeOS')}
                    </Button>
                </div>

                <div className={classes.container}>
                    {rangeOSVersion.isRanged && (
                        <FormControl
                            fullWidth
                            variant="standard"
                        >
                            <InputLabel>
                                {t('osType')}
                            </InputLabel>
                            <Select
                                onChange={this.handleChangeType}
                                value={rangeOSVersion.osVersion || ''}
                            >
                                {OsNamesArray.map((elem, index) => (
                                    <MenuItem
                                        key={elem + index}
                                        value={elem}
                                    >
                                        {elem}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                    {rangeOSVersion.osVersion && rangeOSVersion.isRanged && (
                        <div className={classes.container}>
                            <FormControl className={classes.smallFormControl}>
                                <MultiTypeahead
                                    animatedPlaceholder
                                    value={versionFrom}
                                    titleId="startVersion"
                                    options={currentVersionsArrayFrom}
                                    osVersions={osVersions}
                                    onChangeSuggestion={this.addVersion(range.FROM)}
                                    t={t}
                                />
                            </FormControl>
                            <FormControl className={classes.smallFormControl}>
                                <MultiTypeahead
                                    animatedPlaceholder
                                    value={versionTo}
                                    titleId="endVersion"
                                    options={currentVersionsArrayTo}
                                    osVersions={osVersions}
                                    onChangeSuggestion={this.addVersion(range.TO)}
                                    t={t}
                                />
                            </FormControl>
                        </div>
                    )}
                    {!rangeOSVersion.isRanged && (
                        <FormControl fullWidth>
                            <OSVersionTypeahead
                                isMulti
                                animatedPlaceholder
                                value={versionsList}
                                labelId="osVersion"
                                onChangeSuggestion={this.props.onChangeSuggestion}
                                t={t}
                            />
                        </FormControl>
                    )}
                </div>
            </React.Fragment>
        );
    }
}

OSVersionSelectTypeahead.propTypes = {
    rangeOSVersion: PropTypes.object.isRequired,
    handleChangeRangeType: PropTypes.func.isRequired,
    osVersions: PropTypes.array.isRequired,
    versionsList: PropTypes.array.isRequired,
    onChangeSuggestion: PropTypes.func.isRequired,
    classes: PropTypes.shape({
        container: PropTypes.string,
        rangeButton: PropTypes.string,
        smallFormControl: PropTypes.string,
    }),
};

export default withStyles(styles)(OSVersionSelectTypeahead);
